import type { WorkOrderSubjectType } from './types';

export type SubjectDisplay = {
  /** "Ford Focus 2018 · AB123CD" or "Cliente: Juan Pérez". */
  label: string;
  /** Short label for chips/cards: "AB123CD" or "Juan Pérez". */
  short: string;
  /** Icon name (Ionicons). */
  icon: string;
};

export type SubjectResolver = {
  subjectType: WorkOrderSubjectType;
  /** Resolve display from subject_id (fetch from repo). */
  resolve: (subjectId: string | null) => Promise<SubjectDisplay>;
};

export const DB_WORK_ORDER_SUBJECT_TYPES: readonly WorkOrderSubjectType[] = [
  'vehicle',
  'pet',
  'garment',
  'customer',
];

export const SUBJECT_ICONS: Record<WorkOrderSubjectType, string> = {
  vehicle: 'car-outline',
  pet: 'paw-outline',
  garment: 'shirt-outline',
  customer: 'person-outline',
};

export const SUBJECT_LABELS: Record<WorkOrderSubjectType, string> = {
  vehicle: 'Vehículo',
  pet: 'Mascota',
  garment: 'Prenda',
  customer: 'Cliente',
};

/** Map DB/legacy values to the CHECK-allowed subject type. */
export function normalizeWorkOrderSubjectType(raw: string | null | undefined): WorkOrderSubjectType {
  if (raw === 'fiado') return 'customer';
  if (raw === 'vehicle' || raw === 'pet' || raw === 'garment' || raw === 'customer') return raw;
  return 'customer';
}

/** Fallback display when subject_id is null or not found. */
export function fallbackSubjectDisplay(
  subjectType: WorkOrderSubjectType,
  customerName: string,
): SubjectDisplay {
  if (subjectType === 'customer' || !customerName) {
    return {
      label: customerName ? `Cliente: ${customerName}` : 'Sin cliente',
      short: customerName || 'Sin cliente',
      icon: SUBJECT_ICONS[subjectType],
    };
  }
  return {
    label: `${SUBJECT_LABELS[subjectType]} — ${customerName}`,
    short: customerName,
    icon: SUBJECT_ICONS[subjectType],
  };
}
